import type { GraphApiError } from './graphApiSlice';

/** Narrows a value caught from `.unwrap()` on a graph call. Every error the base query gives has a `status`. */
export const isGraphApiError = (error: unknown): error is GraphApiError => typeof error === 'object' && error !== null && 'status' in error;
